module.exports = __webpack_public_path__ + "static/img/s2.6974cd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/s2.png
// module id = +ru2
// module chunks = 0